import { gql } from '@apollo/client'

import type { PaginatedDataResponse } from '@/lib/apollo/model/pagination'
import type { SubjectBySearchResult } from '@/types/Subject'

export type QueryVars = {
  customerId: string
  query: string
  limit: number
  offset: number
}

export type SubjectsBySearchResponse = {
  searchForSubjects: PaginatedDataResponse<SubjectBySearchResult>
}

export const query = gql`
  query ($customerId: String!, $query: String!, $limit: Int, $offset: Int) {
    searchForSubjects(
      customerId: $customerId
      query: $query
      limit: $limit
      offset: $offset
    ) {
      total
      offset
      limit
      results {
        id
        externalId
        applicationId
        customerId
        updatedAt
        type
        asset {
          price
          attributes {
            address {
              nameOrNumber
              line1
              line2
              city
              country
              postcode
            }
          }
        }
        context {
          name
          firstName
          lastName
          middleName
          email
          mobile
          dob
          nationality
          journeyType
        }
        referenceTier
        avatar
      }
    }
  }
`

export default query
